import { useEffect, useState } from 'react';
import AreaPicker from './pages/AreaPicker';
import MapView from './pages/MapView';
import { onNavigate } from './navigate';

export default function App() {
  const [path, setPath] = useState(location.pathname);

  useEffect(() => onNavigate(() => setPath(location.pathname)), []);

  if (path.startsWith('/map')) return <MapView key={location.search} />;
  return <AreaPicker />;
}
